import React from 'react'

const CrumplePopSignupContext = React.createContext();

const CrumplePopSignupProvider = props => {
    const [CrumplePopSignupState, setCrumplePopSignupState] = React.useState(
        {
            page: 'login',
            loginPage: 'select',
            cpopUser: null,
            cpopToken: null,
            cpopKey: null,
            processing: false,
            migrationInProgress: false,
            orderId: null
        }
    );
    return (
        <CrumplePopSignupContext.Provider value={[CrumplePopSignupState, setCrumplePopSignupState]}>
            {props.children}
        </CrumplePopSignupContext.Provider>
    )
}

export {CrumplePopSignupProvider, CrumplePopSignupContext};